import { FireProvider } from '../providers/fireProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_ACTIVE_FIRES = 'GET_ACTIVE_FIRES';
export const GET_ACTIVE_FIRES_PENDING = 'GET_ACTIVE_FIRES_PENDING';
export const GET_ACTIVE_FIRES_FULFILLED = 'GET_ACTIVE_FIRES_FULFILLED';
export const GET_ACTIVE_FIRES_REJECTED = 'GET_ACTIVE_FIRES_REJECTED';
export const REFRESH_ACTIVE_FIRES = 'REFRESH_ACTIVE_FIRES';
export const REFRESH_ACTIVE_FIRES_PENDING = 'REFRESH_ACTIVE_FIRES_PENDING';
export const REFRESH_ACTIVE_FIRES_FULFILLED = 'REFRESH_ACTIVE_FIRES_FULFILLED';
export const REFRESH_ACTIVE_FIRES_REJECTED = 'REFRESH_ACTIVE_FIRES_REJECTED';

export const GET_LOCAL_FIRE_INFO = 'GET_LOCAL_FIRE_INFO';
export const GET_LOCAL_FIRE_INFO_PENDING = 'GET_LOCAL_FIRE_INFO_PENDING';
export const GET_LOCAL_FIRE_INFO_FULFILLED = 'GET_LOCAL_FIRE_INFO_FULFILLED';
export const GET_LOCAL_FIRE_INFO_REJECTED = 'GET_LOCAL_FIRE_INFO_REJECTED';
export const REFRESH_LOCAL_FIRE_INFO = 'REFRESH_LOCAL_FIRE_INFO';
export const REFRESH_LOCAL_FIRE_INFO_PENDING = 'REFRESH_LOCAL_FIRE_INFO_PENDING';
export const REFRESH_LOCAL_FIRE_INFO_FULFILLED = 'REFRESH_LOCAL_FIRE_INFO_FULFILLED';
export const REFRESH_LOCAL_FIRE_INFO_REJECTED = 'REFRESH_LOCAL_FIRE_INFO_REJECTED';

export const GET_FIRE_PROPERTIES = 'GET_FIRE_PROPERTIES';
export const GET_FIRE_PROPERTIES_PENDING = 'GET_FIRE_PROPERTIES_PENDING';
export const GET_FIRE_PROPERTIES_FULFILLED = 'GET_FIRE_PROPERTIES_FULFILLED';
export const GET_FIRE_PROPERTIES_REJECTED = 'GET_FIRE_PROPERTIES_REJECTED';

export const CLEAR_FIRE_PROPERTIES = 'CLEAR_FIRE_PROPERTIES';
export const CLEAR_FIRE_PROPERTIES_PENDING = 'CLEAR_FIRE_PROPERTIES_PENDING';
export const CLEAR_FIRE_PROPERTIES_FULFILLED = 'CLEAR_FIRE_PROPERTIES_FULFILLED';
export const CLEAR_FIRE_PROPERTIES_REJECTED = 'CLEAR_FIRE_PROPERTIES_REJECTED';

export function getFireMapDataAction(isCached
    ,baseUrl
    ,authId
    ,secret
    ,stdParameters
    ,verbose
    ,latitude
    ,longitude
    ,unitParameters) {
    return async (dispatch) => {
        const results = await Promise.all([
            dispatch(getActiveFires(
                isCached
                ,baseUrl
                ,authId
                ,secret
                ,stdParameters
                ,verbose
            )),
            dispatch(getLocalFireInfo(
                baseUrl
                ,authId
                ,secret
                ,latitude
                ,longitude
                ,stdParameters
                ,unitParameters
                ,verbose
            ))
        ]);
        const activeFires = results[0].value;
        const localFireInfo = results[1].value;
        dispatch(selectFireFromLocalFireInfo(
            activeFires
            ,localFireInfo
            ,baseUrl
            ,authId
            ,secret
            ,latitude
            ,longitude
            ,stdParameters
            ,unitParameters));
    };
}

export function selectFireFromLocalFireInfo(
    activeFires
    ,localFireInfo
    ,baseUrl
    ,authId
    ,secret
    ,latitude
    ,longitude
    ,stdParameters
    ,unitParameters) {
    return dispatch => {
        const nearestFireLat = (localFireInfo && localFireInfo.closestFire && localFireInfo.closestFire.centerLatitude);
        const nearestFireLon = (localFireInfo && localFireInfo.closestFire && localFireInfo.closestFire.centerLongitude);
        if (nearestFireLat && nearestFireLon) {
            const selectedFeature = activeFires && activeFires.features && activeFires.features.find(feature => feature.geometry.coordinates[0] === nearestFireLon && feature.geometry.coordinates[1] === nearestFireLat);
            if (selectedFeature) {
                dispatch(getFireProperties(
                    baseUrl
                    ,authId
                    ,secret
                    ,latitude
                    ,longitude
                    ,selectedFeature.geometry.coordinates[1]
                    ,selectedFeature.geometry.coordinates[0]
                    ,stdParameters
                    ,unitParameters));
            }
        }
    };
}

export function getActiveFires(
    isCached
    ,baseUrl
    ,authId
    ,secret
    ,stdParameters
    ,verbose
) {
    return {
        type: GET_ACTIVE_FIRES,
        payload: getActiveFiresAsync(isCached, baseUrl, authId, secret, stdParameters, verbose)
    };
}

export function refreshActiveFires(baseUrl, authId, secret, stdParameters) {
    return {
        type: REFRESH_ACTIVE_FIRES,
        payload: refreshActiveFiresAsync(baseUrl, authId, secret, stdParameters)
    };
}

async function getActiveFiresAsync(isCached, baseUrl, authId, secret, stdParameters, verbose) {
    const op = new FireProvider(baseUrl, authId, secret);
    return await op.getActiveFires(isCached, stdParameters, verbose);
}

async function refreshActiveFiresAsync(baseUrl, authId, secret, stdParameters) {
    const op = new FireProvider(baseUrl, authId, secret);
    return await op.refreshActiveFires(stdParameters);
}

export function getLocalFireInfo(...params) {

    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        latitude: undefined,
        longitude: undefined,
        stdParameters: undefined,
        unitParameters: undefined,
        verbose: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject); 

    return {
        type: GET_LOCAL_FIRE_INFO,
        payload: getLocalFireInfoAsync(paramsObject)
    };
}

export function refreshLocalFireInfo(
    baseUrl
    ,authId
    ,secret
    ,latitude
    ,longitude
    ,stdParameters
    ,unitParameters
    ,verbose
) {
    return {
        type: REFRESH_LOCAL_FIRE_INFO,
        payload: refreshLocalFireInfoAsync(baseUrl, authId, secret, latitude, longitude, stdParameters, unitParameters, verbose)
    };
}

async function getLocalFireInfoAsync({baseUrl, authId, secret, latitude, longitude, stdParameters, unitParameters, verbose}) {
    const op = new FireProvider(baseUrl, authId, secret);
    return await op.getLocalFireInfo(latitude, longitude, stdParameters, unitParameters, verbose);
}

async function refreshLocalFireInfoAsync(baseUrl, authId, secret, latitude, longitude, stdParameters, unitParameters, verbose) {
    const op = new FireProvider(baseUrl, authId, secret);
    return await op.refreshLocalFireInfo(latitude, longitude, stdParameters, unitParameters, verbose);
}

export function getFireProperties(
    baseUrl
    ,authId
    ,secret
    ,latitude
    ,longitude
    ,fireLatitude
    ,fireLongitude
    ,stdParameters
    ,unitParameters
) {
    return {
        type: GET_FIRE_PROPERTIES,
        payload: getFirePropertiesAsync(baseUrl, authId, secret, latitude, longitude, fireLatitude, fireLongitude, stdParameters, unitParameters)
    };
}

async function getFirePropertiesAsync(baseUrl, authId, secret, latitude, longitude, fireLatitude, fireLongitude, stdParameters, unitParameters) {
    const op = new FireProvider(baseUrl, authId, secret);
    return await op.getFireProperties(latitude, longitude, fireLatitude, fireLongitude, stdParameters, unitParameters);
}

export function clearFireProperties() {
    return {
        type: CLEAR_FIRE_PROPERTIES,
        payload: new Promise(function (resolve) { resolve({ clearSelectedFire: true }); })
    };
}
